import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, IconButton, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import utils from 'components/utils';

const TextWithCopyIcon = props => {
	const { label, text } = props;
	const theme = useTheme();
	const translate = utils.useI18N();

	const handleCopy = () => {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				alert(translate('common.textCopied'));
			})
			.catch(error => {
				console.error('Errore durante la copia del testo: ', error);
			});
	};

	return (
		<Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0.5}>
			<Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
				<Typography variant="caption" sx={{ fontSize: '14px', fontWeight: '600' }}>
					{text}
				</Typography>
				<Typography variant="caption" sx={{ marginTop: '-4px' }}>
					{label}
				</Typography>
			</Stack>
			<Tooltip title={translate('common.textCopiedDesc')}>
				<IconButton onClick={handleCopy}>
					<ContentCopy sx={{ fontSize: '20px' }} />
				</IconButton>
			</Tooltip>
		</Stack>
	);
};

export default TextWithCopyIcon;
